import { useProviderNetwork } from "../context-hooks/useProviderNetwork";
import { useMctFlags } from "./useMctFlags";

/** The earliest plan year with MAPNET coverage data. */
export const MAPNET_MIN_PLAN_YEAR = 2027;

/**
 * Reports whether MAPNET-backed coverage applies to the given plan year.
 * Earlier years stay on the PNAPI/SunFire path even when the flag is on,
 * matching the backend routing in oc-mct-api.
 */
/** TODO[2027-06-01]: Remove year-specific logic (and see if you can delete flag and this hook too) */
export function useMapnetCoverage(year?: string | number): {
  enableMapnetCoverage: boolean;
} {
  const { tmpFeEnableMapnetProviderNetwork } = useMctFlags();
  const { enableProviderNetwork } = useProviderNetwork();
  // Boolean() keeps an undefined flag from leaking out of this hook. The
  // callers thread the result into default-true parameters, where undefined
  // would silently enable behavior the flag never approved.
  const enableMapnetCoverage =
    enableProviderNetwork &&
    Boolean(tmpFeEnableMapnetProviderNetwork) &&
    !!year &&
    Number(year) >= MAPNET_MIN_PLAN_YEAR;

  return { enableMapnetCoverage };
}
